/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chain_Page_Compare_Metric_Repos_SingularInputs */



/**
* | output |
* | --- |
* | "repo" |
*
* @param {Chain_Page_Compare_Metric_Repos_SingularInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_metric_repos_singular = /** @type {((inputs?: Chain_Page_Compare_Metric_Repos_SingularInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Metric_Repos_SingularInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("repo")
});